import { render, staticRenderFns } from "./StageQuestion.vue?vue&type=template&id=4db753a5"
import script from "./StageQuestion.vue?vue&type=script&lang=js"
export * from "./StageQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports